<template>
  <div>
    <template-publish-modal
      :selected-template="selectedTemplate"
      :services-by-zone="servicesByZone"
    />
    <test-version
      :version-settings="version.settings"
      :current-zone="version.zone"
    />
    <drop-zones
      v-if="!fetchingZones"
      :selected-drop-zones="version.settings.drop_zones"
      :zone-names="zoneNames"
      @drop-zones="version.settings.drop_zones = $event"
    />
    <peak-factors
      :selected-peak-factors="version.settings.peak_factors"
      @peak-factors="version.settings.peak_factors = $event"
    />
    <slicings
      :slicings="version.settings.time_slicings"
      @time-slices="version.settings.time_slicings = $event"
    />
    <slicings
      slices-type="distance"
      :slicings="version.settings.distance_slicings"
      @distance-slices="version.settings.distance_slicings = $event"
    />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="fetchingZones || fetchingTemplates"
    >
      <b-card>
        <validation-observer ref="templateFormRef">
          <b-form
            autocomplete="off"
            novalidate
            @submit.prevent="submitTemplate"
          >
            <b-row>

              <b-col md="12">
                <b-form-group
                  :label="'General Section (Timezone: '+version.timezone+')'"
                />
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Name"
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    v-model="version.name"
                  />
                </b-form-group>
                <validation-provider
                  name="Minmum Amount"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Minmum Amount"
                    label-for="minimum-amount"
                  >
                    <b-form-input
                      id="minimum-amount"
                      v-model.number="version.settings.minimum_amount"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Admin Commission"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"

                    label="Admin Commission"
                    label-for="admin-commission"
                  >
                    <b-form-input
                      id="admin-commission"
                      v-model.number="version.settings.admin_commission"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">

                <validation-provider
                  name="Open Meter Amount"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"

                    label="Open Meter Amount"
                    label-for="open-meter-amount"
                  >
                    <b-form-input
                      id="open-meter-amount"
                      v-model.number="version.settings.open_meter_amount"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Tax Amount"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Tax Amount"
                    label-for="tax-amount"
                  >
                    <b-form-input
                      id="tax-amount"
                      v-model.number="version.settings.tax_amount"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>

              </b-col>
              <b-col md="12">
                <b-form-group label="Effective Date Time" />
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Effective Date"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Effective Date"
                    label-for="effective-date"
                  >
                    <b-form-datepicker
                      id="effective-date"
                      v-model="effectiveDate"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Effective Time"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Effective Time"
                    label-for="effective-time"
                  >
                    <b-form-timepicker
                      id="effective-time"
                      v-model="effectiveTime"
                      now-button
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <b-form-group label="Estimates Price Section" />
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Rate"
                  label-for="estimates-rate"
                >
                  <b-form-radio-group
                    id="estimates-rate"
                    v-model="version.settings.estimates.rate"
                    :options="rateOptions"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Rate Value"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Rate Value"
                    label-for="rate-value"
                  >
                    <b-form-input
                      id="rate-value"
                      v-model.number="version.settings.estimates.value"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="12">
                <b-form-group label="Arrival Section" />
              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Amount Per minute"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"
                    label="Amount Per minute"
                    label-for="arrival-amount-per-minute"
                  >
                    <b-form-input
                      id="arrival-amount-per-minute"
                      v-model.number="version.settings.arrival.amount_per_minute"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>

              </b-col>
              <b-col md="6">
                <validation-provider
                  name="Free Waiting Time"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"

                    label="Free Waiting Time"
                    label-for="arrival-free-waiting-time"
                  >
                    <b-form-input
                      id="arrival-free-waiting-time"
                      v-model.number="version.settings.arrival.free_waiting_time"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>

              </b-col>
              <!--  -->
              <b-col md="6">
                <validation-provider
                  name="Maximum Time threshold"
                  rules="required"
                >
                  <b-form-group
                    slot-scope="{ errors }"

                    label="Maximum Time threshold"
                    label-for="arrival-max-time-threshold"
                  >
                    <b-form-input
                      id="arrival-max-time-threshold"
                      v-model.number="version.settings.arrival.maximum_time_threshold"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>

                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col md="6" />
              <b-col md="12">
                <card-collapse
                  border-variant="primary"
                >
                  <template #card-title>
                    <div class="d-flex">
                      <h3 class="mr-2">
                        Upfront Estimates
                      </h3>
                      <b-form-checkbox
                        v-model="version.settings.upfront_estimates.active"
                        switch
                      >
                        Active
                      </b-form-checkbox>
                    </div>
                  </template>
                  <b-row>
                    <b-col md="5">
                      <h4>Distance</h4>
                      <validation-provider
                        name="Minimum Distance Threshold"
                        :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          label="Minimum Distance Threshold"
                          label-for="minimum-distance-threshold"
                        >
                          <b-form-input
                            id="minimum-distance-threshold"
                            v-model.number="version.settings.upfront_estimates.minimum_distance_threshold"
                            type="number"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>

                        </b-form-group>
                      </validation-provider>
                      <b-form-group
                        label="Rate"
                        label-for="upfront-estimates-rate"
                      >
                        <b-form-radio-group
                          id="upfront-estimates-rate"
                          v-model="version.settings.upfront_estimates.distance.rate"
                          :options="rateOptions"
                        />
                      </b-form-group>

                      <validation-provider
                        :name="`Minimum ${distanceLabeling}`"
                        :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          :label="`Minimum ${distanceLabeling}`"
                          label-for="minimum-upfront-distance"
                        >
                          <b-form-input
                            id="minimum-upfront-distance"
                            v-model.number="version.settings.upfront_estimates.distance.minimum"
                            type="number"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>

                        </b-form-group>
                      </validation-provider>
                      <validation-provider
                        :name="`Maximum ${distanceLabeling}`"
                        :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          :label="`Maximum ${distanceLabeling}`"
                          label-for="maximum-upfront-distance"
                        >
                          <b-form-input
                            id="maximum-upfront-distance"
                            v-model.number="version.settings.upfront_estimates.distance.maximum"
                            type="number"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>

                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <hr>
                    <b-col
                      md="2"
                      class="d-flex justify-content-center"
                    >
                      <div class="vertical-line" />
                    </b-col>
                    <b-col md="5">
                      <h4>Time</h4>
                      <!-- Dummy div to inline inputs with each other -->
                      <div style="height:75px" />
                      <b-form-group
                        label="Rate"
                        label-for="upfront-estimates-rate-time"
                      >
                        <b-form-radio-group
                          id="upfront-estimates-rate-time"
                          v-model="version.settings.upfront_estimates.time.rate"
                          :options="rateOptions"
                        />
                      </b-form-group>
                      <validation-provider
                        :name="`Minimum ${timeLabeling}`"
                        :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          :label="`Minimum ${timeLabeling}`"
                          label-for="minimum-upfront-time"
                        >
                          <b-form-input
                            id="minimum-upfront-time"
                            v-model.number="version.settings.upfront_estimates.time.minimum"
                            type="number"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>

                        </b-form-group>
                      </validation-provider>
                      <validation-provider
                        :name="`Maximum ${timeLabeling}`"
                        :rules="version.settings.upfront_estimates.active ? 'required' : ''"
                      >
                        <b-form-group
                          slot-scope="{ errors }"
                          :label="`Maximum ${timeLabeling}`"
                          label-for="maximum-upfront-time"
                        >
                          <b-form-input
                            id="maximum-upfront-time"
                            v-model.number="version.settings.upfront_estimates.time.maximum"
                            type="number"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>

                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </card-collapse>
              </b-col>
              <b-col md="2">
                <b-button
                  v-b-modal.create-peak-factors
                  variant="success"
                >
                  Peak Factors
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  v-b-modal.create-distance-slices
                  variant="success"
                >
                  Distance Slices
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  v-b-modal.add-drop-zones
                  variant="success"
                >
                  Drop Zones
                </b-button>
              </b-col>
              <b-col md="2">
                <b-button
                  v-b-modal.create-time-slices
                  variant="success"
                >
                  Time Slices
                </b-button>
              </b-col>

            </b-row>

            <b-row class="mt-2">
              <b-col
                md="10"
              >
                <b-button
                  v-b-modal.test-version
                  variant="info"
                >
                  Test Pricing
                </b-button>
              </b-col>
              <b-col
                md="1"
                class="d-flex justify-content-end"
              >
                <b-button
                  v-if="$can('write', 'versions') && !isNew"
                  type="button"
                  @click="publishTemplate(version, $event)"
                >
                  Publish
                </b-button>
              </b-col>

              <b-col
                md="1"
                class="d-flex justify-content-end"
              >
                <b-button
                  v-if="$can('write', 'templates')"
                  type="submit"
                  variant="success"
                  :disabled="submitting"
                >
                  {{ isNew ? 'submit' : 'Edit' }}
                </b-button>
              </b-col>

            </b-row>

          </b-form>
        </validation-observer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BFormGroup, BFormInput, BRow, BCol, BFormRadioGroup, BButton, VBModal, BForm, BOverlay, BFormDatepicker, BFormTimepicker, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import DropZones from './DropZones.vue'
import Slicings from './Slicings.vue'
import PeakFactors from './PeakFactors.vue'
import zonesStore from '@/views/zones/zoneStoreModule'
import useTemplateForm from '../../hooks/useTemplateForm'
import TestVersion from '../../../versions/components/version-form/TestVersion.vue'
import templateStore from '../../store'
import TemplatePublishModal from '../TemplatePublishModal.vue'
import CardCollapse from '@/UI/CardCollapse.vue'
import versionsStore from '../../../versions/store'

export default {
  components: {
    BFormCheckbox,
    CardCollapse,
    DropZones,
    Slicings,
    PeakFactors,
    BForm,
    BCard,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormDatepicker,
    BFormTimepicker,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BOverlay,
    TestVersion,
    TemplatePublishModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('zones', zonesStore)
    useRegisterStoreModule('templates', templateStore)
    useRegisterStoreModule('versions', versionsStore)
    return {
      ...useTemplateForm(props, ctx),
      required,
    }
  },
}
</script>

<style>

</style>
